import { Model } from 'pinia-orm'

export default class ComponentFacebook extends Model {

    static get entity() {
        return 'component_facebooks'
    }

    static get primaryKey() {
        return ['component_id'];
    }

    static fields() {
        return {
            component_id: this.attr(null),
            url: this.attr(null),
            translated_url: this.attr(null),
        }
    }

    static formFields() {
        return [
            { name: 'url', value: '' },
            { name: 'translated_url', value: {}, translatable: true },
            { name: 'published', value: {}, translatable: true },
            { name: 'identifier', value: '' },
        ]
    }
}
